<template>
    <div>
    
        <div class="animated fadeIn">
    
            <br />
            <CCard>
                <CRow class="p-3">
                    <CCol sm="12">
                        <h3 class="custom-20px-700 mt-3">Personal Information</h3>
                        <CRow class="mt-3">
                            <CCol sm="2">
                                <div class="text-center">
                                    <span>
                                          <img
      :src="previewImage || (profile.FilePath ? getPic(profile) : require('../assets/img/default.png'))"
      class="grey lighten-2"
      width="50px"
      alt="User Avatar"
    />
                                        </span>
    
                                </div>
                            </CCol>
                            <CCol sm="10">
                                We only support .JPG, .JPEG, or .PNG file.
                                <br />
                                <div class="mt-2">
                                    <input type="file" ref="file" accept=".jpg,.jpeg,.png" style="display: none" @change="onFileSelected" />
                                    <CButton type="button" @click="triggerFileInput" class="custom-bg-blue">Upload Your Photo</CButton>
                                    <!-- <CButton type="button" class="custom-bg-blue bg-white font-color-191919">Delete Image</CButton> -->
                                </div>
    
    
                            </CCol>
    
    
                        </CRow>
                        <CRow class="mt-5">
                            <CCol sm="6">
                                <h3 class="custom-14px-400">First Name</h3>
                                <CInput type="text" v-model="Name" />
    
                                <h3 class="custom-14px-400">Phone Number</h3>
                                <CInput type="text" v-model="PhoneNumber" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400">Email</h3>
                                <CInput type="text" v-model="Email" disabled/>
    
                                <h3 class="custom-14px-400">About</h3>
                                <CInput type="text" v-model="Description" />
    
                                <div class="mt-2 text-right">
                                    <CButton type="button" class="custom-bg-blue" @click="UpdateTuition">Save Profile</CButton>
                                </div>
    
                            </CCol>
                        </CRow>
    
    
                    </CCol>
    
                </CRow>
    
    
    
            </CCard>
        </div>
        <div v-if="isSuccessPopupVisible1" class="popup-all backdrop-all" style="z-index: 1;">
            <div  style="z-index: 1;" class="popup-all1 bg-white">
                <!-- Popup content -->
                <div class="text-center" style="border-radius: 28px 28px 0px 0px;background: rgba(0, 124, 239, 0.08);padding:30px">
                    <img style="max-width:200px" src="../assets/img/Illustration.png" />
                </div>
                    <h3 class="custom-32px-500 mt-4 text-center">Changes Saved</h3>
                    <h3 class="custom-18px-400 text-center">Your profile has been updated successfully..</h3>
                
                <CButton class="bg-1796FD border-16px text-white mt-4" @click="closeSuccess" block><span class="ml-2 mr-2">Close</span></CButton>
            </div>
        </div>
    
    
    
    </div>
</template>
  
  
<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgtips.png";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
    name: "Collapses",
    components: {
        PulseLoader,
        CChartBar,
        Calendar,
    },
    data() {
        return {
            backgroundUrl,
            user: {},
            profile: {},
            UploadModal: false,
            previewImage: null,
            file: null,
            Name: "",
            Email:"",
            PhoneNumber: "",
            Description: "",
            isSuccessPopupVisible1:false
        };
    },
    async mounted() {
        this.SessionUserIdNo();
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;
            this.GetProfilePicture();

        } else {
            this.GoToLogin();
        }
    },
    computed: {},

    methods: {
        OpenUploadPopup() {
            this.UploadModal = true;
        },
        SessionUserIdNo() {
            return this.$API
                .get(this.$LoginUserDetailAdmin, {
                    withCredentials: true,
                })
                .then((response) => {
                this.info = response.data;
                if (response.status == 200 && this.info != null) {
                  this.Name = this.info.name;
                  this.Description = this.info.description;
                  this.Email = this.info.email;
                  this.PhoneNumber = this.info.phoneNumber;
                  this.Id = this.info.id;
                }
              });
        },
        GetProfilePicture() {
            this.$API.get(this.$ViewProfilePictureAdmin, { withCredentials: true })
                .then(response => {
                    if (response.status === 200 && response.data) {
                        this.profile = response.data;

                    }
                })
                .catch(error => {
                    console.error("Error fetching profile:", error);
                });
        },

        UpdateProfileImage: function() {
            const formData = new FormData();
            formData.append("image", this.file);
            formData.append("userId", this.Id);

            return this.$API
                .post(this.$UploadTcProfilePhoto, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.$dialog.alert("Success save").then(function() {});
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to save").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
            console.log(this.file);
        },
        getPic(user) {
            return `https://www.flyhigh.my/${user.FilePath}`;
        },
        triggerFileInput() {
            this.$refs.file.click(); // triggers file dialog
        },

        onFileSelected(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.file = file;

            // Optional: Immediately preview the image locally before uploading
            const reader = new FileReader();
            reader.onload = (e) => {
                this.previewImage = e.target.result;
            };
            reader.readAsDataURL(file);

            // Optionally call upload here if you want auto-upload:
            // this.UpdateProfileImage();
            this.UpdateProfileImage();
        },
        UpdateTuition: function() {
            const formData = new FormData();
            formData.append("Name", this.Name);
            formData.append("PhoneNumber", this.PhoneNumber);
            formData.append("Description", this.Description);
            formData.append("Id", this.Id);


            return this.$API
                .post(this.$EditTuitionCenter, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                       this.isSuccessPopupVisible1 = true;
                    } else {
                        this.$dialog.alert("Error to save").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess()
        {
            this.isSuccessPopupVisible1 = false;
        }

    },
};
</script>